<template>
	<div class="appr-container m-0 p-0" style="background-color: #000000;">
		<div class="container-fluid my-0" v-if="(isMobile && !isPortrait) || !isMobile">
			<div class="row justify-content-center m-0" v-if="videoDataObj.src">
				<div id="full-video-container" class="col-lg-10 position-relative m-0">
					<div class="inner-vid-conteiner m-0 w-100">
						<div class="inner-vid-wrap m-0 w-100">
							<div class="vid-wrapper w-100 h-100 position-relative">

								<video
									ref="cinqueRagioniX"
									:poster="coverUrl"
									@play="onPlay"
									@timeupdate="videoTimeWatch"
									@ended="onVideoEnd"
									v-show="step < 6"
									:controls="false"
									controlsList="nodownload"
									:height="videoDataObj.height"
									:width="videoDataObj.width"
									webkit-playsinline
									playsinline
								>
									<source :src="videoDataObj.src" :type="videoDataObj.type">
									Your browser does not support the video tag.
								</video>

								<transition name="fade">
									<div id="btn-container" class="button-container text-center black-game-container" v-if="showBtn">
										<div class="row px-4">
											<div class="col-md-12 border-default-black bg-white text-center p-2" :class="{'d-none':  !(step == 1)}">
												<p class="ultra-bold text-size-box-1 mb-0">
													“Io non fumo, o meglio...<br>
													dipende da chi me lo chiede!<br>Fumo quando i miei amici fumano.<br>
													Fumo se mi offrono un tiro.<br>
													Fumo se ho l'ansia!”
												</p>
											</div>

											<div class="col-12 mt-2x" :class="{'d-none': !(step == 1)}">
												<p class="fs-2 text-white ultra-bold text-center text-size-box-5 mt-0">
													Hai mai pensato quante volte fumi<br>
													anche se “non fumi”?
												</p>
											</div>

											<div class="col-12 text-center mt-2x">
												<button class="btn btn-pink approf rounded-pill btn-lg px-5 mx-auto text-down-sm-09" @click.prevent="startVideo">
													{{btnText}}
												</button>
											</div>
										</div>
									</div>
								</transition>

								<transition name="fade">
									<div class="video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 6">
										<div class="video-end-inner-container w-100 h-100">
											<div class="row justify-content-center align-items-center h-100">
												<div class="col-md-10 text-center bg-white border-default-black mt-1 mt-lg-2 mt-xl-4 py-2 mx-3">
													<div class="row">
														<div class="col-12">
															<p class="bold text-size-box-3 lh-1-2 mb-0">
																Tra gli 11 e i 15 anni, circa il 50% dei ragazzi e delle ragazze
																ha fumato almeno una volta nella vita.
																3 adolescenti su 10 fumano in modo abituale*.
															</p>
														</div>
														<div class="col-12">
															<img :src="separatrPointsUrl" class="img-fluid" alt="sepatrator">
														</div>
														<div class="col-12">
															<p class="text-size-box-2 ultra-bold mb-1">Forse è capitato anche a te di fumare per sentirti:</p>
														</div>
														<div class="col-12 px-5">
															<img :src="imgEndUrl" class="img-fluid w-100 px-5" alt="fumare per sentirti...">
														</div>
														<div class="col-12">
															<p class="text-size-box-2 ultra-bold mb-0">Ma il fumo non può darti nulla di tutto questo.</p>
															<p class="bold mb-0">*Rapporto HBSC (OMS), 2018</p>
														</div>
													</div>
												</div>

												<div class="col-12 text-center">
													<button class="btn btn-pink approf rounded-pill btn-lg px-5 mx-auto text-down-sm-09" @click.prevent="nextStep">
														{{btnText}}
													</button>
												</div>

											</div>
										</div>
									</div>
								</transition>

								<transition name="fade">
									<div class="video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 7">
										<!-- <div id="btn-container" class="button-container text-center black-game-container-2" v-if="step == 7"> -->
											<div class="row px-4 h-100 align-items-center justify-content-center">
												<div class="col-md-12 border-default-black bg-white text-center" style="padding: 3%; max-width: 90%">
													<div class="row">
														<div class="col-12">
															<p class="ultra-bold text-size-box-9 mb-0">
																È normale sentirsi a <span class="text-pink">disagio</span>, desiderare di <span class="text-pink">essere accettati</span>,<br>
																voler <span class="text-pink">apparire diversi</span>, più <span class="text-pink">forti</span>, più <span class="text-pink">affascinanti</span>.<br>
																Capita anche quando si diventa grandi,<br>
																a volte semplicemente perché le giornate sono stressanti,<br>
																o perchè si litiga con persone care.
															</p>
														</div>
														<div class="col-12">
															<img :src="separatrPointsUrl" class="img-fluid" alt="sepatrator">
														</div>
														<div class="col-12">
															<p class="ultra-bold text-size-box-9 mb-0">
																<span class="text-pink">Ma la sigaretta non è una bacchetta magica. Non trasforma nulla.</span><br>
																Rovina solo la tua salute e genera dipendenza,<br>
																privandoti della libertà di scegliere.<br>
															</p>
														</div>

													</div>
												</div>

												<div id="btn-go" class="text-center col-12">
													<button class="btn btn-pink approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
												</div>

											</div>
										</div>
									<!-- </div> -->
								</transition>

								<transition name="fade">
									<div class="d-flex w-100 h-100 align-items-center justify-content-center video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 8">
										<div class="row px-4 h-100 align-items-center">

											<div class="col-12 align-self-end">
												<p class="text-white ultra-bold text-center text-size-box-10 end mb-0 full-text">
													Questo discorso vale anche<br>
													per i nuovi prodotti del tabacco.<br>
													Scopri di più nel percorso interattivo<br>“A ogni costo”.
												</p>
											</div>

											<div class="col-12 text-center">
												<a :href="linkUrl.back" class="btn btn-pink approf rounded-pill mr-3 go-next-back mb-2"><span class="va-m">TORNA INDIETRO</span></a>
												<a :href="linkUrl.next" class="btn btn-pink approf rounded-pill go-next-back mb-2"><span class="va-m">VAI AL PROSSIMO PERCORSO</span></a>
											</div>

										</div>
									</div>
								</transition>

							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-10">
					{{timeVideo}}
				</div> -->
			</div>
		</div>

		<div id="mobile-icon-container" class="container-fluid" v-else>
			<div class="row">
				<div class="col-12">
					<div class="img-rotate position-relative" style="height: 100vh;">
						<img id="phone-gif" :src="rotateScreenUrl" alt="Rotate phone">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const jQuery = window.jQuery
import { urlBase, themeDir, urlHost } from '../../variables.js'
import VimeoVideoResolution from '../../mixins/VimeoVideoResolution'
import axios from 'axios'

export default {
	name: 'RootCinqueRagioniPerComponent',
	mixins: [VimeoVideoResolution],

	data() {
		return {
			ajaxObj: window.ajax_object,
			themeUrl: '',
			coverUrl: '',
			videoUri: '/videos/545730623',
			showBtn: true,
			showIntroText: true,
			btnText: 'ENTRA',
			step: 1,
			timeVideo: '',
			separatrPointsUrl: '',
			imgEndUrl: '',
			isMobile: false,
			isPortrait: false,
			rotateScreenUrl: '',
			linkUrl:{
				back: '',
				next: ''
			}
		}
	},

	methods: {
		loadVideo() {
			let _self = this
			let formData = new FormData()
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('action', 'nl_vimeo_video_info')
			formData.append('video_uri', this.videoUri)

			axios.post( this.ajaxObj.ajax_url, formData)
				.then(function(response){
					// console.log(response.data.body.files[2].link)
					_self.checkResolution(response.data.body.files)
				})
		},

		startVideo() {
			this.$refs.cinqueRagioniX.play()
		},
		onPlay() {
			this.showBtn = false
		},
		onVideoEnd() {
			this.step = 6
		},

		videoTimeWatch() {
			this.timeVideo = Math.trunc(this.$refs.cinqueRagioniX.currentTime * 100) / 100

			if (this.timeVideo >= 10.50 && this.step == 1) {
				this.$refs.cinqueRagioniX.currentTime = 10.50
				this.$refs.cinqueRagioniX.pause()
				this.step = 2
				this.btnText = 'AVANTI'
				this.showBtn = true
			} else if(this.timeVideo >= 20.50 && this.step == 2) {
				this.$refs.cinqueRagioniX.currentTime = 20.50
				this.$refs.cinqueRagioniX.pause()
				this.step = 3
				this.showBtn = true
			} else if(this.timeVideo >= 35.00 && this.step == 3) {
				this.$refs.cinqueRagioniX.currentTime = 35.00
				this.$refs.cinqueRagioniX.pause()
				this.step = 4
				this.showBtn = true
			} else if(this.timeVideo >= 45.50 && this.step == 4) {
				this.$refs.cinqueRagioniX.currentTime = 45.50
				this.$refs.cinqueRagioniX.pause()
				this.step = 5
				this.showBtn = true
			}
		},

		nextStep() {
			if(this.step != 7) {
				this.step = 7
				this.showBtn = false
			} else {
				this.step = this.step + 1;
			}

		},

		isMobileFn() {
			this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		},
		isPortraitFn() {
			this.isPortrait = (window.innerHeight > window.innerWidth)
		},

		handleOrientationChange() {
			this.isMobileFn()
			this.isPortraitFn()
			if(this.isPortrait) {
				this.isMobile = true
				this.isPortrait = false
				this.removeEvent()
			}
		},
		removeEvent() {
			window.removeEventListener("orientationchange", this.handleOrientationChange, true)
		},

		calculateVideoWidth() {
			let screen_h = screen.availHeight
			let screen_w = ((screen_h * 16) / 9) - 20

			jQuery('#full-video-container').css('max-width', screen_w + 'px')
		},
	},

	mounted() {
		let _self = this

		jQuery('#wrapper-navbar, #wrapper-footer').addClass('d-none')
		this.themeUrl = urlBase + themeDir
		this.isMobileFn()
		this.isPortraitFn()

		jQuery(window).resize(function() {
			_self.calculateVideoWidth()
		})

		if(this.isMobile && this.isPortrait) {
			this.rotateScreenUrl = this.themeUrl + 'img/rotate_screen.gif'
			window.addEventListener("orientationchange", this.handleOrientationChange, true)
		}

		this.coverUrl = this.themeUrl + 'img/covers/5ragioniper_CoverBack.jpg'
		this.separatrPointsUrl = this.themeUrl + 'img/riga_pallini.png'
		this.imgEndUrl = this.themeUrl + 'img/img_end_5ragioni.jpg'
		this.loadVideo()
		this.linkUrl.back = urlBase + urlHost + '5-ragioni-per'
		this.linkUrl.next = urlBase + urlHost +'a-ogni-costo'
	},
	updated() {
		this.calculateVideoWidth()
	}
}
</script>

<style scoped>
	.go-next-back {
		padding-left: 2.8% !important;
		padding-right: 2.8% !important;
		padding-bottom: 0.5% !important;
		padding-top: 0.5% !important;

		margin: 1.2%;
	}
	@media (max-width: 991.98px) {
		.text-size-box-10.end {
			font-size: 2.5rem;
		}
	}
	@media (max-width: 767.98px) {
		.full-text {
			font-size: 1.2rem !important;
		}
		.text-size-box-10.end {
			font-size: 1.8rem;
		}
	}
	@media (min-width: 992px) {
		.go-next-back {font-size: 1.1rem !important;}
	}

	video {
		width: 100%;
		height: auto;
	}
	.inner-vid-conteiner {
		width: 100%;
		position: absolute;
		top:50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.inner-vid-wrap {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}
	#btn-container {
		position: absolute;
		bottom: 8%;
		left: 50%;
		transform: translateX(-50%);
	}
	.btn {
		border-width: 4px;
		font-weight: 800;
	}
	@media (max-width: 991.98px) {
		.btn {
			padding: .25rem 3rem;
		}
	}
	.video-end-container {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .8s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
	#phone-gif {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);;
	}
	#full-video-container {height: 100vh;}
	.mt-2x {margin-top: 2%;}
</style>
